import { useQuery } from '@tanstack/react-query';

import getReinforcementActivityData from '@/modules/api/tasks/getReinforcementActivityData.endpoint';
import { QUERY_KEYS } from '@/v2/constants/QueryKeys';

export default function useGetReinforcementActivityDataQuery({
  taskActivityId,
  enabled,
}: {
  taskActivityId?: number | string;
  enabled: boolean;
}) {
  return useQuery({
    queryKey: [QUERY_KEYS.REINFORCEMENT_ACTIVITY_DATA, taskActivityId],
    queryFn: () => getReinforcementActivityData(taskActivityId),
    enabled: enabled && !!taskActivityId,
    refetchOnWindowFocus: false,
    meta: {
      notification: {
        error: "We couldn't load the review. Please try again.",
      },
    },
  });
}
